import {
    WithStyles,
    withStyles,
    Grid,
    Checkbox
} from "@material-ui/core";
import cx from 'classnames';
import React, { Component } from "react";
import { connect } from "react-redux";
import { questionCardStyle } from "../styles/questionCardStyle";
import getDefaultFormData from '../../mylibrary/types/ContentFromDataDefault'
import contentService from '../../mylibrary/services/contentService';
import MyPATQuestionBar from "../../common/MyPATQuestionBar";
import { bindActionCreators } from "redux";
import contentRequestService from '../services/contentRequestServices';
import _ from 'lodash';
import { contentRequestAccordianActions } from "../reducers/contentRequestAccordianState";



interface QuestionCardProps extends WithStyles<typeof questionCardStyle> {
    passageDetail: any,
    count: number,
    code: string,
    SelectAll: boolean,
    requestId: string,
    handleQuestionState: Function,
    history: any,
    contentRequestItemsId: any,
    handleChooseFromLibrary: Function
    attachedQuestions: any,
    handleReset: Function,
    progressBar: any,
    progressBarForQuestion: Function,
    progressBarForTest: Function,
    contentRequestId: string,
    type: string,
    accordianState: any,
    contentRequestData: any,
    handleSaveQuestion: Function,
    handleCheckboxState: Function,
    accordianIndex: number,
    questionId: number,
    HandleSelectAll: any,
    removeQuestionFromCheckboxState: Function,
    checkboxDisable: boolean,
    setContentRequestItemsIdForFirstTime: Function,
    contentRequestItemsIdForFirstTime: string,
    setProgressBarForQuestion: Function,
    setProgressBarForTest: Function,
    checkboxVisiblity: boolean,
    accordianTouched: any,
    questionIndex: number,
    handleResetQuestionForUnresolvedCount: Function
    handleChooseFromLibraryForUnresolvedContent: Function;
    handleSaveQuestionForUnresolvedContent: Function;
    setAccordingTouchIndex: Function;
}

interface QuestionCardState {
    arr: any
}

class QuestionCard extends Component<QuestionCardProps, QuestionCardState> {
    constructor(props: QuestionCardProps) {
        super(props);
        this.state = {
            arr: []
        };
    }

    handleSaveForUnresolvedContentRequest = (res: any, accordianIndex: any,index: number) => {
        const { _id, contentId, } = res.responseObject;
        const { accordianTouched, setAccordingTouchIndex, questionIndex } = this.props;
        let newCloneState = JSON.parse(JSON.stringify(accordianTouched));
        newCloneState[accordianIndex].questionContent[index-1].attachedQuestions = {
            ...newCloneState[accordianIndex].questionContent[index-1].attachedQuestions,
            contentId,
            content_Id: _id,
            previousVersion: { ...newCloneState[accordianIndex].questionContent[index-1].attachedQuestions.previousVersion }
        };
        setAccordingTouchIndex(newCloneState);
    }
    handleCreate = (questionCode: string, index: number, type: string, contentRequestItemsId: any, accordianIndex: number, unresolvedFeedbackCount?: number) => {
        const defaultFromData = getDefaultFormData(questionCode);
        if (questionCode === '5') {
            defaultFromData.questionType = 'Paragraph';
        }
        defaultFromData.questionCode = Number(questionCode);
        const { requestId = '', handleQuestionState, contentRequestData, setContentRequestItemsIdForFirstTime, handleCheckboxState, questionId } = this.props;

        handleQuestionState();
        localStorage.setItem('passageData', JSON.stringify(this.props.passageDetail));
        localStorage.setItem('isPassageData', 'true');
        localStorage.setItem('unresolvedFeedbackCount', unresolvedFeedbackCount ? String(unresolvedFeedbackCount) : '0');
        contentService.save('', 'question', defaultFromData, false)
            .then((res: any) => {

                if (!contentRequestItemsId && !this.props.accordianTouched[accordianIndex]['questionContent'].filter((ele: any) => ele.attachedQuestions.contentId).length) {
                    const reqBody = {
                        contents: [
                            {
                                sequenceNo: index,
                                content_id: res.responseObject._id
                            }
                        ],
                        type: 'question',
                        contentRequestQuestionId: questionId,
                        contentRequestId: contentRequestData._id
                    }
                    contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                        if (response) {
                            const { contentRequestItem: { _id = '' } = {} } = response;
                            setContentRequestItemsIdForFirstTime({ id: _id });
                            window.open(
                                `${window.location.origin.toString()}/content/edit/question/${questionCode}/${res.responseObject._id}question/${requestId}`, "_blank");
                                if (!unresolvedFeedbackCount) {
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 2000)
                                }
                        }
                    });
                } else {
                    if (contentRequestItemsId) {
                        if (unresolvedFeedbackCount) {
                            this.handleSaveForUnresolvedContentRequest(res, accordianIndex, index);
                            window.open(
                                `${window.location.origin.toString()}/content/edit/question/${questionCode}/${res.responseObject._id}question/${requestId}`, "_blank");
                        } else {
                            const { _id } = contentRequestItemsId;
                            const reqBody = {
                                contents: [{
                                    sequenceNo: index,
                                    contentId: res.responseObject._id
                                }]
                            }
                            contentRequestService.createQuestionForPutContentRequest(_id, { ...reqBody }).then((response: any) => {
                                window.open(
                                    `${window.location.origin.toString()}/content/edit/question/${questionCode}/${res.responseObject._id}question/${requestId}`, "_blank");
                            });

                        }
                    } else {
                        const reqBody = {
                            contents: [{
                                sequenceNo: index,
                                contentId: res.responseObject._id
                            }]
                        };
                        contentRequestService.createQuestionForPutContentRequest(this.props.contentRequestItemsIdForFirstTime, { ...reqBody }).then((response: any) => {
                            window.open(
                                `${window.location.origin.toString()}/content/edit/question/${questionCode}/${res.responseObject._id}question/${requestId}`, "_blank");
                        });
                    }
                    if (!unresolvedFeedbackCount) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2500)
                    }
                }
            })

    }



    render = () => {
        const { classes, count = 0, code = '', handleChooseFromLibrary,
            handleReset, attachedQuestions, progressBarForQuestion, progressBarForTest, setProgressBarForQuestion, setProgressBarForTest, type, contentRequestItemsId, accordianState, contentRequestData, accordianIndex, handleSaveQuestion } = this.props;
        let contentId = '';
        let content_Id = '';
        let passageData = [];
        let isJobCompleted = false;

        if (code === '5') {
            contentId = attachedQuestions.contentId;
            content_Id = attachedQuestions.content_Id;
            isJobCompleted = attachedQuestions.isJobCompleted;
            passageData = attachedQuestions.passageData;
        } else {
            contentId = attachedQuestions.contentId;
            content_Id = attachedQuestions.content_Id;
            isJobCompleted = attachedQuestions.isJobCompleted;
        }
        let saveReset = false;
        let importCreate = false;
        contentId && content_Id ? saveReset = true : importCreate = true;
        const contentRequestItemsIdForQuestion = accordianState[accordianIndex].contentRequestItemsId ? accordianState[accordianIndex].contentRequestItemsId._id : '';

        return (
            <>
                <MyPATQuestionBar
                    code={code}
                    passageData={attachedQuestions.passageData}
                    unresolvedFeedbackCount={attachedQuestions.unresolvedFeedbackCount}
                    checkBoxAdd={true}
                    SelectAll={this.props.SelectAll}
                    checkboxVisiblity={this.props.checkboxVisiblity}
                    accordianIndex={this.props.accordianIndex}
                    checkboxDisable={this.props.checkboxDisable}
                    removeQuestionFromCheckboxState={() => { this.props.removeQuestionFromCheckboxState() }}
                    handleCheckboxState={this.props.handleCheckboxState}
                    importCreate={importCreate}
                    saveReset={saveReset}
                    contentId={contentId}
                    content_Id={content_Id}
                    isJobCompleted={isJobCompleted}
                    attachedQuestions={attachedQuestions}
                    status={status}
                    count={count}
                    type={type}
                    HandleSelectAll={this.props.HandleSelectAll}
                    handleSaveQuestion={handleSaveQuestion}
                    progressBarForQuestion={progressBarForQuestion}
                    progressBarForTest={progressBarForTest}
                    setProgressBarForQuestion={setProgressBarForQuestion}
                    handleCreate={() => { this.handleCreate(code, count, type, contentRequestItemsId, accordianIndex, attachedQuestions.unresolvedFeedbackCount) }}
                    handleResetQuestionForUnresolvedCount={this.props.handleResetQuestionForUnresolvedCount}
                    handleReset={handleReset}
                    handleChooseFromLibrary={this.props.handleChooseFromLibrary}
                    contentRequestItemsId={contentRequestItemsIdForQuestion}
                    contentRequestId={contentRequestData._id}
                    urlRequestType='question'
                    questionIndex={this.props.questionIndex}
                    handleChooseFromLibraryForUnresolvedContent={this.props.handleChooseFromLibraryForUnresolvedContent}
                    previousVersion={attachedQuestions.previousVersion}
                    newVersion={attachedQuestions}
                    handleSaveQuestionForUnresolvedContent={this.props.handleSaveQuestionForUnresolvedContent}
                    requestId={this.props.requestId}
                />

            </>

        )
    }
}


const mapStateToProps = (state: any) => {
    const { contentRequestData } = state;
    localStorage.setItem('allStates', JSON.stringify({ contentRequestData }));
    return {
        progressBarForQuestion: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
        progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForQuestion', {}),
        contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime', {}),
        accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
    setProgressBarForTest: contentRequestAccordianActions.setProgressForTest,
    setContentRequestItemsIdForFirstTime: contentRequestAccordianActions.setContentRequestItemsIdForFirstTime,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(questionCardStyle)(QuestionCard));
